import { AmenityType, PropertyAmenitiesUpdatePayload } from 'models/Amenity';
import { PropertyRulesUpdatePayload, RuleType } from 'models/Rule';
import { typedEntries } from 'utils/funcs';
import {
  CategorizedAmenitiesFormDirtyFields,
  CategorizedAmenitiesFormValues,
} from './CategorizedAmenities.schema';

type CategorizedPayload = {
  amenities: PropertyAmenitiesUpdatePayload;
  rules: PropertyRulesUpdatePayload;
};

const useCategorizedAmenitiesUpdatePayload = () => {
  return ({
    dirtyFields,
    formValues: { amenities },
  }: {
    dirtyFields: CategorizedAmenitiesFormDirtyFields;
    formValues: CategorizedAmenitiesFormValues;
  }): CategorizedPayload => {
    return typedEntries(dirtyFields.amenities ?? {}).reduce(
      (result, [type]) => {
        const common = {
          description: amenities?.[type]?.description ?? null,
          state: amenities?.[type]?.value ? 'ON' : 'OFF',
        };

        if (type in AmenityType) {
          return {
            ...result,
            amenities: [
              ...result.amenities,
              {
                ...common,
                chargeFrequency: amenities?.[type]?.chargeFrequency ?? null,
                amenityType: type,
                price: amenities?.[type]?.price ?? null,
              },
            ],
          } as CategorizedPayload;
        }

        if (type in RuleType) {
          return {
            ...result,
            rules: [...result.rules, { ...common, rule: type }],
          } as CategorizedPayload;
        }

        return result;
      },
      { rules: [], amenities: [] } as CategorizedPayload,
    );
  };
};

export default useCategorizedAmenitiesUpdatePayload;
